import type { CategoryFilterOption, FilterOption } from '../domain/models';
import type { CategoryFilterOptionDto, FilterOptionDto } from './dtos';

const mapCategoryFilterOptions = (dto: Record<string, CategoryFilterOptionDto>, selectedIds: string[]): CategoryFilterOption[] => {
  const optionsEntries = Object.entries(dto);
  return optionsEntries.map(([key, value]) => ({
    id: key,
    title: value.title,
    checked: value.checked || selectedIds.includes(key),
    disabled: value.disabled,
    image: value.image ?? null,
  }));
};

const mapFilterOptions = (dto: Record<string, FilterOptionDto>, selectedIds: string[]): FilterOption[] => {
  const optionsEntries = Object.entries(dto);
  return optionsEntries.map(([key, value]) => ({
    id: key,
    title: value.title,
    checked: value.checked || selectedIds.includes(key),
    disabled: value.disabled,
  }));
};

const wizardApiMappers = {
  mapFilterOptions,
  mapCategoryFilterOptions,
};

export default wizardApiMappers;
